import { render, staticRenderFns } from "./OrderDrawer.vue?vue&type=template&id=736e5d3a&scoped=true"
import script from "./OrderDrawer.vue?vue&type=script&lang=js"
export * from "./OrderDrawer.vue?vue&type=script&lang=js"
import style0 from "./OrderDrawer.vue?vue&type=style&index=0&id=736e5d3a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "736e5d3a",
  null
  
)

export default component.exports